import { apiDelete, apiGet, apiPost, apiPut, getBootstrap, type RequestOptions } from './index'
import type {
  PrepExportPayload,
  PrepExportSettingsResponse,
  RotatePrepExportTokenPayload,
  SavePrepExportSettingsPayload,
  PrepExportFeed,
  PrepExportFeedsResponse,
  SavePrepExportFeedPayload,
} from '../types/prepExport'

export function getSuperadminPrepExportSettings(
  stationId: number,
  options: RequestOptions = {},
): Promise<PrepExportSettingsResponse> {
  const params = new URLSearchParams({ station_id: String(stationId) })
  return apiGet<PrepExportSettingsResponse>(`superadmin/prep-export/settings?${params.toString()}`, options)
}

export function getSuperadminPrepExportFeeds(stationId: number): Promise<PrepExportFeedsResponse> {
  return apiGet<PrepExportFeedsResponse>(`superadmin/prep-export/feeds?station_id=${encodeURIComponent(String(stationId))}`)
}
export function saveSuperadminPrepExportFeed(payload: SavePrepExportFeedPayload): Promise<{ feed: PrepExportFeed }> {
  const path = payload.id ? `superadmin/prep-export/feeds/${encodeURIComponent(payload.id)}` : 'superadmin/prep-export/feeds'
  return payload.id ? apiPut<{ feed: PrepExportFeed }>(path, payload) : apiPost<{ feed: PrepExportFeed }>(path, payload)
}
export function deleteSuperadminPrepExportFeed(stationId: number, feedId: string): Promise<{ deleted: boolean }> {
  return apiDelete<{ deleted: boolean }>(`superadmin/prep-export/feeds/${encodeURIComponent(feedId)}?station_id=${encodeURIComponent(String(stationId))}`)
}
export function rotateSuperadminPrepExportFeedToken(stationId: number, feedId: string): Promise<{ feed: PrepExportFeed }> {
  return apiPost<{ feed: PrepExportFeed }>(`superadmin/prep-export/feeds/${encodeURIComponent(feedId)}/rotate`, { station_id: stationId })
}

export function saveSuperadminPrepExportSettings(
  payload: SavePrepExportSettingsPayload,
  options: RequestOptions = {},
): Promise<PrepExportSettingsResponse> {
  return apiPut<PrepExportSettingsResponse>('superadmin/prep-export/settings', payload, options)
}

export function rotateSuperadminPrepExportToken(
  payload: RotatePrepExportTokenPayload,
  options: RequestOptions = {},
): Promise<PrepExportSettingsResponse> {
  return apiPost<PrepExportSettingsResponse>('superadmin/prep-export/settings/rotate', payload, options)
}

export function buildPrepExportUrlFromToken(token: string): string {
  const { restBase } = getBootstrap()
  const url = new URL('prep/export', restBase)
  url.searchParams.set('token', token)
  return url.toString()
}

export function getPrepExportPayloadByToken(
  token: string,
  options: RequestOptions = {},
): Promise<PrepExportPayload> {
  const encoded = encodeURIComponent(token.trim())
  return apiGet<PrepExportPayload>(`prep/export?token=${encoded}`, options)
}
